import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {initAds, showBanner, hideBanner, resumeBanner, moveBanner, removeBanner} from "../lib/ads.js";
import useStore from "../zustand/useStore";
import {Capacitor} from "@capacitor/core";

/**
 * Pass a config object mapping routes (string or RegExp) to a placement:
 *   { place: 'TOP' | 'BOTTOM' | 'HIDE' }
 *
 * Example:
 * const config = {
 *   "/dashboard/home": { place: "BOTTOM" },
 *   "/dashboard/news": { place: "TOP" },
 *   "/dashboard/profile": { place: "HIDE" },
 *   [/^\/product\/\d+$/]: { place: "BOTTOM" },
 * };
 */
export function useBannerManagerNative() {
    const { pathname } = useLocation();
    const {isDetailOpen,isJobDetailOpen,menuOpen,openEditUserDetail,notificationSheetOpen,isAssignmentDetailOpen,isMatrimonialDetailOpen} = useStore();
    const isBigScreen = window.innerWidth >= 1000;

    // simple matcher: supports string exact or RegExp key
    function resolvePlacement(path,isOpen) {
        if(isBigScreen){
            if (path === "/dashboard/home") {
                return 'HORIZONTAL';
            }else if(path === "/dashboard/assignments" || path === "/dashboard/matrimonial"){
                return 'VERTICAL';
            }else if(path === "/dashboard/job-portal"){
                return 'SQUARE';
            }
        }else{
            if(isOpen){
                return 'BOTTOM';
            }else if (path === "/dashboard/home") {
                if(Capacitor.getPlatform() !== 'ios'){
                    return 'CENTER';
                }else{
                    return "HIDE";
                }
            }
        }
        return "HIDE";
    }

    useEffect(() => {
        if(Capacitor?.getPlatform() !== 'ios'){
            (async () => {
                await initAds();
            })();
        }
    }, []);

    useEffect(() => {
        if(Capacitor?.getPlatform() !== 'ios') {
           removeBanner().then(() => {
                if(menuOpen || openEditUserDetail) return;
                setTimeout(async () => {
                    const isOpen = (isDetailOpen || notificationSheetOpen || isJobDetailOpen || isAssignmentDetailOpen || isMatrimonialDetailOpen)
                    const place = resolvePlacement(pathname, isOpen);

                    if (place === "HIDE") {
                        await hideBanner().catch(() => {
                            console.log('')
                        });
                        return;
                    }
                    try {
                        await showBanner({place});
                        // if (!mountedOnce.current) {
                        //     mountedOnce.current = true;
                        //     await showBanner({place}); // first time show
                        // } else {
                        //     // already showed once in the app session
                        //     await moveBanner(place).catch(() => {
                        //         console.log('')
                        //     });
                        //     await resumeBanner().catch(() => {
                        //         console.log('')
                        //     });
                        // }
                    } catch (err) {
                        console.warn("Banner error:", err?.message || err);
                    }
                }, 2000)
            })
        }
    }, [pathname,isDetailOpen,isJobDetailOpen,openEditUserDetail,menuOpen,notificationSheetOpen,isAssignmentDetailOpen,isMatrimonialDetailOpen]);
}
